import React, { useState } from "react"

import { Avatar, Badge, Box, Card, Divider, Grid } from "@mui/material"
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel"

// import SlideDialog from "components/SlideDialog/SlideDialog"
// import clubPlaceholder from "../../../../../assets/club-placeholder.png";
// import exchange from "../../../../../assets/exchange_white.png";

import moment from "moment"
// import MatchGameForm from "./MatchGameForm"
import { color } from "constant/constant"
import { MatchLiveStatusMap } from "helper/Match"
import { getUserAvatar } from "helper/User"

function MatchGameCard ({
    match, isResult, form, isDragging, isEdited, active, loadMatchInfo = () => {}, loadInfoOnly = () => {}, setLoading = false
}) {
    const [ openDialog, setOpenDialog ] = useState(false)
    let dur = match.isTournament ? moment.duration(moment(match.endMatch).diff(moment(match.startMatch))) : null
    let difMins = match.isTournament ? moment(match.endMatch).format('mm') != moment(match.startMatch).format('mm') : false
    let h = match.isTournament ? Math.floor(dur.asHours()) : null
    let m = match.isTournament ? (dur.minutes() < 1 && difMins) ? 1 : dur.minutes() : null
    const matchHours = match.isTournament ? `${h}h ${m}m` : null
    // const active = false
    return (
        <>
            <Card sx={{ 
                // minWidth: '200px',
                position: 'relative',
                borderWidth: active ? 2 : 1,
                borderColor: active ? "primary.main" : "divider",
                bgcolor: active ? "primary.main" : "background.paper",
                color: active ? "primary.contrastText" : "text.primary",
                transition: "all .15s ease",
                boxShadow: '2px 4px 6px 0px rgba(87,87,87,0.2)',
             }}>
                <div
                    onClick={() => {
                    if (isResult || isDragging) return;
                        setOpenDialog(!openDialog);
                    }}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 10,
                        cursor: isResult || isDragging ? isDragging ? 'grab' : 'default' : 'pointer'
                    }}
                ></div>
                <div>
                    <Grid container>
                        <Grid container xs={12} alignItems={"center"}>
                            <Grid item xs={8.5} px={1}><TCLabel bold>{`${match.name}` || `Round 1`}
                                {match.isCustom ? <span style={{
                                    fontSize: 10,
                                    marginLeft: 2
                                }}>(Custom)</span> : ''}
                            </TCLabel>
                            </Grid>
                            <Grid item xs={3.5} textAlign={"right"} px={1}><TCLabel bold style={{ fontSize: 15 }}>{match.finalScore}</TCLabel></Grid>
                            <Grid item xs={12}>
                                <Divider sx={{ marginY: 0.6, marginTop: 0.2, background: color.blueIndoor_1}}/>
                            </Grid>
                        </Grid>
                        <UserAvatar scores={match.setScores} match={match} avatarSize={{
                            width: {xs: 40, md: 40, lg: 40}, height: {xs: 40, md: 40, lg: 40}
                        }} clubSize={{
                            width: 15, height: 15
                        }} size="md"/>
                        <Grid container xs={12} justifyContent={"center"} alignItems={"center"} 
                            // mt={-1}
                            mt={1}
                        >
                            {/* <Grid xs={4} textAlign={"center"}><TCLabel bold style={{fontSize: 10}}>Set 1</TCLabel></Grid>
                            <Grid xs={4} textAlign={"center"}><TCLabel bold style={{fontSize: 10}}>Set 2</TCLabel></Grid>
                            <Grid xs={4} textAlign={"center"}><TCLabel bold style={{fontSize: 10}}>Set 3</TCLabel></Grid> */}
                        </Grid>
                    </Grid>
                    <Divider sx={{ marginY: 0, background: color.blueIndoor_1}}/>
                    {
                        !match.isTournament &&
                        <Grid textAlign={"center"} sx={{
                            my: 0.5
                        }}>
                            {!isEdited && <TCLabel subtitle>Ongoing</TCLabel>}
                            {isEdited && <TCLabel subtitle>Submitted by {match.editBy}</TCLabel>}
                        </Grid>
                    }
                    {
                        match.isTournament &&
                        <Grid container textAlign={"center"} sx={{
                            my: 0.5
                            // , justifyContent: 'space-between'
                        }}>
                            {
                                match.status == "not before"  &&
                                <Grid item px={1} textAlign={"right"}>
                                    <TCLabel>{match.status == "not before" ? `Not before ${match.date} ${match.hour}` : ''}</TCLabel>
                                </Grid>
                            }
                            {
                                (match.status !== "not before" && match.status !== "not set") &&
                                <Grid item xs={12} px={1} textAlign={"center"}
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",   // center horizontally
                                        alignItems: "center",       // center vertically
                                        textAlign: "center",
                                    }}
                                >
                                    <div style={{ display: "flex", width: '100%',  justifyContent: 'center', alignItems: 'center'}}>
                                        <TCLabel style={{ marginRight: 2 }}>{MatchLiveStatusMap(match)}</TCLabel>
                                        {
                                            (match.startMatch && match.endMatch) &&
                                            <div><TCLabel subtitle>(Time: {matchHours})</TCLabel></div>
                                        }
                                    </div>
                                </Grid>
                            }
                            {
                                match.status == "not set" &&
                                <Grid item xs={12}>
                                    <TCLabel>{match.status == "not set" ? "TBD" : ""}</TCLabel>
                                </Grid>
                            }
                        </Grid>
                    }
                </div>
            </Card>
            {/* {
                openDialog &&
                <SlideDialog
                    isOpen={openDialog} 
                    setIsOpen={(e) => {
                        setOpenDialog(false)
                    }}
                >
                    <MatchGameForm form={form} match={match} isOpen={openDialog} setOpenDialog={() => {
                        setOpenDialog(false)
                    }} loadMatchDetail={() => {
                        loadMatchInfo()
                        setOpenDialog(false)
                    }} loadInfoOnly={() => {
                        loadInfoOnly()
                    }}setLoading={setLoading}
                    />
                </SlideDialog>
            } */}
        </>
    )
}

// function MatchGameForm ({
//     match,
//     form,
//     isOpen,
//     loadMatchDetail = () => {},
//     loadInfoOnly,
//     setLoading = false
//     // updateMatchDummy
// }) {

//     const containerRef = useRef(null);

//     const [ score, setScore ] = useState({
//         scoreTeamA: 0,
//         scoreTeamB: 0
//     })
//     const [ matchBE, setMatchBE ] = useState(null)
//     const [ scores, setScores ] = useState([])
//     const [ allowAdd, setAllowAdd ] = useState(false)
//     const [ finalScore, setFinalScore ] = useState(match.finalScore || "0-0")
//     const [ replacePlayer, setReplacePlayer ] = useState(null)
//     const [ playerToReplace, setPlayerToReplace ] = useState(null)
//     const [ joi, setJoi ] = useState({
//         replacePlayer: null
//     })

//     useEffect(() => {
//         if (!replacePlayer && !playerToReplace) { setJoi({replacePlayer: null}) }
//         if (replacePlayer && !playerToReplace) { setJoi({replacePlayer: 'required'}) }
//         if (replacePlayer && playerToReplace) {
//             if (playerToReplace.name && playerToReplace.gender) { setJoi({replacePlayer: null}) }
//             else { setJoi({replacePlayer: 'required'}) }
//         }
//     }, [replacePlayer, playerToReplace])

//     const loadMatch = async () => {
//         let { data, error } = await getMatchScore({
//             matchId: match._id
//         })
//         if (error) { console.log('error', error) }
//         if (data) {
//             setAllowAdd(data.canEdit)
//             if (Array.isArray(data.setScores)) {
//                 let scores = data.setScores
//                     .map(s => {
//                         if (typeof s !== 'string') return null;
//                         const [a, b] = s.split('-').map(Number);
//                         return { scoreTeamA: a, scoreTeamB: b };
//                     })
//                     .filter(Boolean); // buang null
//                 setScores(scores.length ? scores : [{ scoreTeamA: 0, scoreTeamB: 0 }]);
//                 setMatchBE(data)
//                 console.log('score:',scores)
//             } else {
//                 setScores([{ scoreTeamA: 0, scoreTeamB: 0 }]);
//             }
//         }
//     }

//     const submitSetScoreMatch = async () => {
//         setLoading(true)
//         // normalize scores
//         let normalizeScores = scores.filter(v => {
//             return v.scoreTeamA > 0 || v.scoreTeamB > 0
//         })
//         // check replacePlayer
//         if (replacePlayer && playerToReplace) {
//             await replacePlayerService({
//                 matchId: match._id,
//                 body: {
//                     ...playerToReplace,
//                     replacePlayer
//                 },
//             }, () => {
//                 loadMatchDetail();
//                 setPlayerToReplace(null);
//                 setReplacePlayer(null);
//             })
//         }
//         let { data, error } = await submitSetScore({
//             matchId: match._id,
//             scores: normalizeScores
//         })
//         if (error) { console.log('error', error); setLoading(false) }
//         if (data) { 
//             loadMatchDetail()
//         }
//     }

//     useEffect(() => {
//         if(isOpen) {
//             loadMatch()
//         }
//     }, [isOpen])

//     useEffect(() => {
//         let finalScoreA = 0
//         let finalScoreB = 0
//         let filterScores = scores.filter(v => {
//             if (!(v.scoreTeamA == 0 && v.scoreTeamB == 0)) {
//                 return v
//             }
//         })
//         if (filterScores.length > 1) {
//             console.log('here', filterScores)
//             for (let i = 0; i < filterScores.length; i ++) {
//                 if (filterScores[i].scoreTeamA > filterScores[i].scoreTeamB) {
//                     finalScoreA += 1
//                 } else if (filterScores[i].scoreTeamA < filterScores[i].scoreTeamB) {
//                     finalScoreB += 1
//                 }
//             }
//         } else if (filterScores.length > 0) {
//             finalScoreA = filterScores[0].scoreTeamA
//             finalScoreB = filterScores[0].scoreTeamB
//         }
//         setFinalScore(`${finalScoreA} - ${finalScoreB}`)
//     }, [scores])

//     const scrollToBottom = () => {
//         console.log("here scroll to Bottom")
//         if (containerRef.current) {
//             containerRef.current.scrollTo({
//                 top: containerRef.current.scrollHeight,
//                 behavior: 'smooth',
//             });
//         }
//     }

//     const startMatch = async () => {
//         let { data, error } = await startMatchService({
//             matchId: match._id
//         })
//         loadMatchDetail()
//     }

//     const endMatch = async () => {
//         let { data, error } = await endMatchService({
//             matchId: match._id
//         })
//         loadMatchDetail()
//     }

//     return (
//         <div style={{
//             // height: '100vh',
//             // paddingTop: '16px',
//             // marginTop: 16
//         }}>
//             <Grid container xs={12}>
//                 <Grid item xs={8.5} px={1}><TCLabel bold>{`${match.name}` || `Round 1`}
//                     {match.isCustom ? <span style={{
//                         fontSize: 10,
//                         marginLeft: 2
//                     }}>(Custom)</span> : ''}
//                 </TCLabel>
//                 </Grid>
//                 <Grid xs={3.5} textAlign={"right"}><TCLabel bold style={{ fontSize: 15 }}>{finalScore}</TCLabel></Grid>
//                 <Grid item xs={12}>
//                     <Divider sx={{ marginY: 0.6, marginTop: 0.2, background: color.blueIndoor_1}}/>
//                 </Grid>
//             </Grid>
//             <div ref={containerRef} style={{
//                 maxHeight: '74vh', 
//                 overflow: 'auto'
//             }}>
//                 <Grid container justifyContent={"center"}>
//                     <DragAvatar form={form} matchBE={matchBE} match={match} loadMatchDetail={loadInfoOnly} loadMatch={loadMatch} 
//                         replacePlayerId={replacePlayer ? replacePlayer._id : null}
//                         setReplacePlayer={setReplacePlayer}/>
//                     <MatchScoreInput backendScores={scores} scoreChanges={(e) => {
//                         setScore({
//                             ...e.score
//                         })
//                         setScores([...e.scores])
//                     }} allowAdd={allowAdd} matchSetScore={scores} scrollToBottom={() => {
//                         scrollToBottom()
//                     }}/>
//                 </Grid>
//                 <Grid sx={{
//                     p: 0.5,
//                     pb: 4
//                 }}>
//                     {
//                         replacePlayer &&
//                         <TCAccordion title={`Replace ${replacePlayer.name}`}>
//                             <ReplacePlayer matchId={match._id} players={match ? [...match.playersSideA, ...match.playersSideB].map(v => v._id.toString()) : []} form={form} replacePlayer={replacePlayer}
//                                 reloadMatch={() => {
//                                     loadMatchDetail(); 
//                                     loadMatch();
//                                     handleClose();
//                                 }}
//                                 setPlayertoReplaceForm={(e) => {
//                                     setPlayerToReplace((prev) => ({
//                                         ...prev,
//                                         ...e
//                                     }))
//                                 }}
//                             />
//                         </TCAccordion>
//                     }
//                 </Grid>
//             </div>
//             <div style={{
//                 display: 'flex',
//                 position: 'absolute',
//                 justifyContent: 'right',
//                 bottom: 16, left: 16, right: 16, gap: 8
//             }}>
//                 {
//                     match.isTournament && 
//                     <MKButton sx={{p: 0, pl: 1, pr: 1, width: '40%'}} color={"primary"} disabled={!allowAdd || joi.replacePlayer || match.endMatch} onClick={() => {
//                         if (!match.startMatch) { 
//                             startMatch()
//                         } else {
//                             endMatch()
//                         }
//                     }}>{match.startMatch ? "End" : "Start"}</MKButton>
//                 }
//                 <MKButton sx={{p: 0, pl: 1, pr: 1, width: '100%', maxWidth: '444px'}} color={"primary"} 
//                     disabled={!allowAdd || joi.replacePlayer || (match.isTournament && !match.startMatch)} onClick={() => {
//                     if (allowAdd) {
//                         if (replacePlayer && !(playerToReplace.name && playerToReplace.gender)) { return; }
//                         submitSetScoreMatch()
//                     }
//                 }}>Submit</MKButton>
//             </div>
//         </div>
//     )
// }


function UserAvatar ({
    match,
    scores,
    avatarSize,
    clubSize = {width: 20, height: 20},
    size = "lg",
    paddingX = 1
}) {
    const winnerTeam = match.winner !== "draw" ? match?.isTournament ? match?.endMatch ? match?.winner : '' : match?.winner : null;
    return (
        <Box sx={{
            display: 'flex',
            justifyContent: match.playersSideA.length > 1 ?'space-between' : 'center',
            gap: match.playersSideA.length > 1 ? 0 : 3,
            width: '100%',
            paddingX: paddingX,
            minHeight: 80
        }} >
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                textAlign: match.playersSideA.length > 1 ? 'start' : 'start',
                alignItems: match.playersSideA.length > 1 ? 'start' : 'start',
                opacity: winnerTeam && (winnerTeam === "a" ? 1 : 0.4),
                pointerEvents: winnerTeam && (winnerTeam === "a" ? 'auto' : 'none'),
                transition: 'opacity 0.3s ease',
            }}>
                {/* Avatars */}
                <Box sx={{ overflow: 'hidden', display: "flex", gap: 0.5, zIndex: 0 }}>
                    {match.playersSideA.map((value, index) => (
                        <Box key={value._id} sx={{
                            position: 'relative',
                            zIndex: match.playersSideA.length - index,
                            ml: index === 0 ? 0.8 : -1.5,
                            flexShrink: 0,
                        }}>
                            <Badge
                            overlap="circular"
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            badgeContent={
                                <>
                                {
                                    value.swapped &&
                                    <div style={{
                                        marginTop: 0,
                                        width: 10, height: 10,
                                        backgroundColor: color.blueIndoor_2,
                                        borderRadius: 5,
                                    }}>
                                        {/* <img style={{
                                            marginLeft: 2, marginBottom: 1
                                        }} src={exchange} width={7} height={7}/> */}
                                    </div>
                                }
                                </>
                                // <SmallAvatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
                            }>
                                <Avatar
                                    key={value._id}
                                    onClick={(e) => {
                                        e.stopPropagation(true)
                                        // if (data.hideUsername) { return; }
                                        // handleClick(e, {
                                        //     ...value.user,
                                        //     appliedDate: value.appliedDate || null
                                        // })
                                    }}
                                    style={{
                                        ...avatarSize
                                    }}
                                    bgColor={"transparent"}
                                    src={getUserAvatar(value)} size={size}
                                    alt={value.name}
                                    sx={{
                                        // width: { xs: 35, sm: 43, md: 51 },
                                        // height: { xs: 35, sm: 43, md: 51 },
                                        ...avatarSize,
                                        border: '1.5px solid white',
                                        flexShrink: 0,
                                        position: 'relative'
                                    }}
                                />
                            </Badge>
                        </Box>
                    ))}
                </Box>

                {/* Text */}
                <Box sx={{ textAlign: 'start' }}>
                    { match.playersSideA.map(value => {
                        return(
                            <div key={value._id} style={{
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                {
                                    value.club &&
                                    <Grid item sx={{ ml: -0.6}}>
                                        {/* <Avatar sx={{...clubSize}} src={value.club ? value.club.logo : clubPlaceholder} /> */}
                                    </Grid>
                                }
                                <Grid item sx={{ mt: 0.2, ml: !value.club ? 1.5 : 0.2}}>
                                    <TCLabel subtitle bold overflowLine={1} maxChars={8}>{value.name}</TCLabel>
                                </Grid>
                            </div>
                        )
                    })}
                </Box>
            </Box>
            <Grid textAlign={"center"} sx={{ mt: 2, minWidth: 30 }}>
                {
                    (scores && scores.length > 1) ? scores.map( (v, index) => {
                        return (<TCLabel bold style={{fontSize: 10}}>{v}</TCLabel>)})
                    : ''
                }
            </Grid>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: match.playersSideA.length > 1 ? 'start' : 'start',
                opacity: winnerTeam && (winnerTeam === "b" ? 1 : 0.4),
                pointerEvents: winnerTeam && (winnerTeam === "b" ? 'auto' : 'none'),
                transition: 'opacity 0.3s ease',
            }}>
                {/* Avatars */}
                <Box sx={{ overflow: 'hidden', display: "flex", 
                justifyContent: 'flex-end',
                    gap: 0.5, zIndex: 0  }}>
                    {match.playersSideB.map((value, index) => (
                        <Box key={value._id} sx={{
                            position: 'relative',
                            zIndex: match.playersSideA.length - index,
                            ml: index === 0 ? 1 : -1.5,
                            flexShrink: 0,
                        }}>
                            <Badge
                            overlap="circular"
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            badgeContent={
                                <>
                                {
                                    value.swapped &&
                                    <div style={{
                                        marginTop: 0,
                                        width: 10, height: 10,
                                        backgroundColor: color.blueIndoor_2,
                                        borderRadius: 5,
                                    }}>
                                        {/* <img style={{
                                            marginLeft: 2, marginBottom: 1
                                        }} src={exchange} width={7} height={7}/> */}
                                    </div>
                                }
                                </>
                                // <SmallAvatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
                            }>
                                <Avatar
                                    key={value._id}
                                    onClick={(e) => {
                                        e.stopPropagation(true)
                                        // if (data.hideUsername) { return; }
                                        // handleClick(e, {
                                        //     ...value.user,
                                        //     appliedDate: value.appliedDate || null
                                        // })
                                    }}
                                    style={{
                                        ...avatarSize
                                    }}
                                    bgColor={"transparent"}
                                    src={getUserAvatar(value)} size={size}
                                    alt={value.name}
                                    sx={{
                                        ...avatarSize,
                                        border: '1.5px solid white',
                                        flexShrink: 0,
                                        position: 'relative'
                                    }}
                                />
                            </Badge>
                        </Box>
                    ))}
                </Box>

                {/* Text */}
                <Box sx={{ textAlign: 'start' }}>
                    { match.playersSideB.map(value => {
                        return(
                            <div key={value._id} style={{
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                {
                                    value.club &&
                                    <Grid item sx={{ ml: -0.6}}>
                                        {/* <Avatar sx={{...clubSize}} src={value.club ? value.club.logo : clubPlaceholder} /> */}
                                    </Grid>
                                }
                                <Grid item sx={{ mt: 0.2, ml: !value.club ? 1 : 0.2}}>
                                    <TCLabel subtitle bold overflowLine={1} maxChars={8}>{value.name}</TCLabel>
                                </Grid>
                            </div>
                        )
                    })}
                </Box>
            </Box>
        </Box>
    )
}

export default MatchGameCard